import '../paedml-modal.tag'
import '../paedml-form-input.tag'

<paedml-modal-hub-host-parameters>
  <paedml-modal prefix={opts.prefix} heading={opts.heading} opname={opname} edit={edit} selectedrowsfunc={opts.selectedrowsfunc} idcol={opts.idcol} idtextcol={opts.idtextcol}
    submitfunc={submitHandler} ref="modal">
  
    <yield to="fields">
    <div if={parent.loading} class="d-flex justify-content-center pt-5 pb-5">
        <p class="my-auto">PaedML Hub Host-Parameter werden aktualisiert...</p>
        <div class="sk-wave">
          <div class="sk-rect sk-rect1"></div>
          <div class="sk-rect sk-rect2"></div>
          <div class="sk-rect sk-rect3"></div>
          <div class="sk-rect sk-rect4"></div>
          <div class="sk-rect sk-rect5"></div>
        </div>
      </div>

      <div class="paedml-input-group" show={!parent.loading}>
        <div class="row">
          <div class="col-md-6">
              <paedml-form-input name="hostName" label="Hostname" 
                required data-msg="Bitte geben Sie den Hostnamen ein"
                />
          </div>
          <div class="col-md-6">
              <paedml-form-input name="ipAddress" label="IP Adresse" 
                required data-msg="Bitte geben Sie die IP Adresse ein"
                />
            </div>
        </div>
        <div class="row">
          <div class="col-md-6">
              <paedml-form-input name="defaultGateway" label="Default Gateway" 
                required data-msg="Bitte geben Sie den Gateway ein"
                />
          </div>
          <div class="col-md-6">
              <paedml-form-input name="searchDomain" label="Search Domain" 
                required data-msg="Bitte geben Sie den Domain ein"
                />
            </div>
        </div>
        <div class="row">
          <div class="col-md-6">
              <paedml-form-input name="intranetNtpServer" label="Intranet NTP Server" 
                required data-msg="Bitte geben Sie den Server ein"
                />
            </div>
            <div class="col-md-6">
              <paedml-form-input name="ldapHostname" label="LDAP-Server Hostname" 
                required data-msg="Bitte geben Sie den Hostnamen ein"
                />
            </div>
        </div>
      </div>

      <div class="paedml-input-group" show={!parent.loading}>
        <div class="row">
          <div class="col-md-12">
              <paedml-form-input name="acmeEmail" label="E-Mail" 
                placeholder='E-Mail-Adresse für Lets Encrypt Zertifikat(e)'
                data-rule-emailextra data-msg-emailextra="Bitte geben Sie eine gültige E-Mailadresse ein."
                />
          </div>
        </div>
      </div>

      <div class="paedml-input-group" show={!parent.loading}>
        <div class="row">
          <div class="col-sm-12">
            <div class="form-group">
              <label>Nameservers</label>
              <textarea class="form-control" maxlength=4097 data-rule-maxlength=4096 data-msg-maxlength="Es sind bis zu 4096 Zeichen erlaubt" name="nameServers" cols="28" rows="10"></textarea>
            </div>
          </div>
        </div>
      </div>

    </yield>
  </paedml-modal>
    
    <script>
      import {autoMapRowToData} from '../../util/api-util'
      import * as R from 'ramda'
      import API from '../../api'

      this.session = Session
      this.opname = this.opts.opname

      this.data = {}

      this.on('update', () => {
        this.loading = false
      })

      const normalizeList = str => str ? str.split('\n').map(R.trim).filter(e => !R.isEmpty(e)) : []

      this.on('dataRequested', () => {
        this.loading = true
          return API.hub.getHostparams()
            .then(rsp => {
              const [data, status] = rsp
              
              this.loading = false

              data.nameServers = R.join('\n', data.nameServers) 
              this.data = data
              
              this.refs.modal.trigger('refreshData')
            })
      })

      this.submitHandler = formData => {
        const nameServers = normalizeList(formData.nameServers)
        const payload = { nameServers }
        payload.hostName = formData.hostName
        payload.ipAddress = formData.ipAddress
        payload.defaultGateway = formData.defaultGateway
        payload.searchDomain = formData.searchDomain
        payload.intranetNtpServer = formData.intranetNtpServer
        payload.acmeEmail = formData.acmeEmail
        payload.ldapHostname = formData.ldapHostname

          return API.hub.saveHostparams(payload)
            .then(rsp => {
              const [data, status] = rsp
              if (status.success) {
                
                this.parent.trigger('reloadTable')
                return this.opname + ' erfolgreich durchgeführt'
              }

              console.error('error-status', status)
              console.error('error-data', data)
              if (data.message) {
                return Promise.reject(data.message)
              }
              return Promise.reject('Fehler bei ' + this.opname + '! PaedML Hub Host-Parameter wurden nicht gesetzt.')
            })
        }

    </script>
</paedml-modal-hub-host-parameters>
